import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE =
  "حاسبة الوقت اللازم لتعلم اللغة الفرنسية - احسب مدة تعلم الفرنسية";
const DESCRIPTION =
  "استخدم حاسبة الوقت لدينا لتحديد المدة الزمنية الدقيقة التي تحتاجها للوصول إلى مختلف مستويات اللغة الفرنسية بدءًا من المبتدئ (A1) حتى المتقدم (C2). بفضل هذه الأداة، يمكنك الحصول على تقدير مخصص للوقت بناءً على مستوى التزامك، سرعة تعلمك، والعوامل الشخصية الأخرى. استفد من هذه الحاسبة لتخطيط دراستك وتحقيق أهدافك اللغوية بفعالية، الخاصة بتقدير الساعات المطلوبة.";
const KEYWORDS =
  "تعلم الفرنسية, حاسبة الوقت, تقدير الوقت لتعلم اللغة, مستويات اللغة الفرنسية, A1 إلى C2, مدة تعلم اللغة الفرنسية, إتقان اللغة الفرنسية,";
const OG_URL =
  "https://do-calculate.com/calculator/ar/french-learning-time-calculator/";
const EnglishLearningTimeCalculator = () => {
  const [lessonsPerWeek, setLessonsPerWeek] = useState("");
  const [lessonTime, setLessonTime] = useState("");
  const [timeUnit, setTimeUnit] = useState("minutes");
  const [timeFormat, setTimeFormat] = useState("weeks");
  const [totalWeeklyHours, setTotalWeeklyHours] = useState("");
  const [timeToLevels, setTimeToLevels] = useState({});
  const [error, setError] = useState("");
  const LEVELS = {
    A1: 100,
    A2: 200,
    B1: 400,
    B2: 650,
    C1: 950,
    C2: 1200,
  };
  const calculateTotalHours = (lessonsPerWeek, lessonTime, timeUnit) => {
    const lessonTimeInHours =
      timeUnit === "minutes"
        ? parseFloat(lessonTime) / 60
        : parseFloat(lessonTime);
    return parseFloat(lessonsPerWeek) * lessonTimeInHours;
  };
  const calculateTimeForLevels = (totalWeeklyHours) => {
    let timeToLevels = {};
    let accumulatedHours = 0;
    Object.entries(LEVELS).forEach(([level, hoursRequired], index) => {
      accumulatedHours += hoursRequired;
      const weeks = accumulatedHours / totalWeeklyHours;
      timeToLevels[level] = formatTime(weeks);
    });
    return timeToLevels;
  };
  const formatTime = (weeks) => {
    switch (timeFormat) {
      case "days":
        return (weeks * 7).toFixed(1) + " أيام";
      case "months":
        return (weeks / 4).toFixed(1) + " شهور";
      case "years":
        return (weeks / 52).toFixed(1) + " سنوات";
      default:
        return weeks.toFixed(1) + " أسابيع";
    }
  };
  const handleCalculate = () => {
    try {
      const lessonsPerWeekValue = parseFloat(lessonsPerWeek);
      const lessonTimeValue = lessonTime.includes(":")
        ? parseFloat(lessonTime.split(":")[0]) +
          parseFloat(lessonTime.split(":")[1]) / 60
        : parseFloat(lessonTime);
      if (lessonsPerWeek && lessonTime) {
        const totalHours = calculateTotalHours(
          lessonsPerWeekValue,
          lessonTimeValue,
          timeUnit
        );
        setTotalWeeklyHours(totalHours.toFixed(2) + " ساعات بالأسبوع");
        const levelsTime = calculateTimeForLevels(totalHours);
        setTimeToLevels(levelsTime);
        setError("");
      } else {
        throw new Error("يرجى إدخال عدد الدروس في الأسبوع و متوسط مدة الدرس.");
      }
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>
              حاسبة الوقت اللازم لتعلم اللغة الفرنسية
            </h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تقوم هذه الحاسبة بتقدير الوقت اللازم للوصول إلى كل مستوى من
                  مستويات إجادة اللغة الفرنسية بناءً على روتين دراستك.{" "}
                </p>
                <p>
                  يمكن أن يساعدك هذه الحاسبة أيضًا في الإجابة على الأسئلة
                  المتعلقة بـ <strong>مستويات اللغة الفرنسية</strong>، مثل "كم
                  شهر يحتاج الشخص لإتقان اللغة الفرنسية؟" و"ما هي مدة تعلم
                  اللغة الفرنسية؟". يستخدم هذا الحساب بيانات تقريبية تعتمد على
                  متوسط الساعات المطلوبة لتعلم اللغة الفرنسية، ويمكنك استخدامه
                  لتخطيط دراستك بناءً على{" "}
                  <strong>مستويات اللغة الفرنسية</strong> المختلفة. يرجى
                  ملاحظة أن الأرقام تعتبر تقريبية، حيث يعتمد العدد الفعلي
                  للساعات التي يحتاجها الطالب على عوامل عدة، مثل خلفية اللغة،
                  شدة الدراسة، العمر، مقدار التعرض للغة خارج الفصول الدراسية،
                  وجودة الدروس، وغيرها من العوامل الشخصية.
                </p>
                <p>
                  بفضل هذه الحاسبة، يمكنك تتبع تقدمك بشكل دقيق وتعديل روتينك
                  لزيادة كفاءة التعلم وتحقيق أهدافك اللغوية بفعالية، بغض النظر
                  عن مستوى اللغة الفرنسية الذي تسعى للوصول إليه.
                </p>
                <p>
                  تم تطوير الحاسبة بالاعتماد على الإطار المرجعي الأوروبي المشترك للغات (CEFR)
                </p>
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    حاسبة الوقت اللازم لتعلم اللغة الفرنسية
                  </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          دروس في الأسبوع
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="أدخل عدد الدروس"
                        value={lessonsPerWeek}
                        onChange={(e) => setLessonsPerWeek(e.target.value)}
                        className="form-control"
                        style={{ width: "50%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label htmlFor="timeUnit" className="form-label ms-2">
                          متوسط مدة الدرس
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل مدة الدرس"
                        value={lessonTime}
                        onChange={(e) => setLessonTime(e.target.value)}
                        className="form-control"
                        style={{ width: "50%" }}
                      />
                      <select
                        id="timeUnit"
                        value={timeUnit}
                        onChange={(e) => setTimeUnit(e.target.value)}
                        className="form-select ms-2"
                        style={{ width: "25%" }}
                      >
                        <option value="minutes">دقائق</option>
                        <option value="hours">ساعات</option>
                      </select>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label htmlFor="timeFormat" className="form-label ms-2">
                          صيغة الوقت للمستويات
                        </label>
                      </b>
                      <select
                        id="timeFormat"
                        value={timeFormat}
                        onChange={(e) => setTimeFormat(e.target.value)}
                        className="form-select ms-2"
                        style={{ width: "25%" }}
                      >
                        <option value="days">أيام</option>
                        <option value="weeks">أسابيع</option>
                        <option value="months">شهور</option>
                        <option value="years">سنوات</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                    <br />
                    { error && (
                      <p style={{ color: "red" }}>{error}</p>
                    )}
                    <br />
                    { totalWeeklyHours && (
                      <div className="p-3 mb-2 bg-success text-white">
                        <hr />
                        <p> النتائج:</p>
                        <p>
                          {" "}
                          إجمالي الساعات الأسبوعية: <b>{totalWeeklyHours}</b>
                        </p>
                        <p>
                          {" "}
                          <b>{timeToLevels.A1}</b> هو الوقت من المستوى A1 إلى A2
                        </p>
                        <p>
                          <b>{timeToLevels.A2}</b> هو الوقت من المستوى A2 إلى B1
                        </p>
                        <p>
                          <b>{timeToLevels.B1}</b> هو الوقت من المستوى B1 إلى B2
                        </p>
                        <p>
                          <b>{timeToLevels.B2}</b> هو الوقت من المستوى B2 إلى C1
                        </p>
                        <p>
                          <b>{timeToLevels.C1}</b> هو الوقت من المستوى C1 إلى C2
                        </p>
                        <p>
                          <b>{timeToLevels.C2}</b> هو إجمالي الوقت من المستوى A1
                          إلى C2
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                ما هي مستويات اللغة الفرنسية؟
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                مستويات اللغة الفرنسية هي تصنيفات تحدد مدى إجادتك للغة وتساعدك
                على فهم تقدمك في تعلم اللغة. يُستخدم إطار العمل الأوروبي المشترك
                المرجعي للغات (CEFR) لتصنيف هذه المستويات، والتي تشمل:
              </p>
              <ul>
                <li>
                  <strong>A1 (مبتدئ):</strong> مستوى أساسي جدًا حيث يمكنك فهم
                  واستخدام تعابير يومية بسيطة.
                </li>
                <li>
                  <strong>A2 (ما قبل المتوسط):</strong> يمكنك التعامل مع مهام
                  بسيطة تتطلب تبادل معلومات مباشرة.
                </li>
                <li>
                  <strong>B1 (متوسط):</strong> يمكنك التعامل مع معظم المواقف
                  التي قد تواجهها أثناء السفر في منطقة ناطقة بالفرنسية.
                </li>
                <li>
                  <strong>B2 (ما بعد المتوسط):</strong> يمكنك التفاعل بفعالية مع
                  الناطقين بالفرنسية وتفهم المواضيع المعقدة.
                </li>
                <li>
                  <strong>C1 (متقدم):</strong> يمكنك استخدام اللغة بمرونة
                  وفعالية في الحياة الاجتماعية والمهنية.
                </li>
                <li>
                  <strong>C2 (طليق):</strong> لديك القدرة على فهم واستخدام اللغة
                  بمستوى عالٍ جدًا من الطلاقة والدقة.
                </li>
              </ul>
              هذا التصنيف يساعدك في تحديد موقعك الحالي وتخطيط خطواتك التالية نحو
              تحسين مهاراتك اللغوية.
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                لماذا من المهم معرفة مستواك في اللغة الفرنسية؟
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                معرفة مستواك الحالي في اللغة الفرنسية أمر ضروري لتخطيط رحلة
                تعلمك بفعالية. من خلال فهم مستواك، يمكنك:
              </p>
              <ul>
                <li>
                  <strong>تتبع تقدمك:</strong> تحديد مدى تقدمك من مستوى إلى آخر.
                </li>
                <li>
                  <strong>تحديد أهداف تعلم واقعية:</strong> وضع أهداف مناسبة
                  بناءً على مستواك الحالي.
                </li>
                <li>
                  <strong>اختيار الموارد التعليمية المناسبة:</strong> اختيار
                  الكتب والدورات التدريبية التي تناسب مستواك.
                </li>
                <li>
                  <strong>تخطيط المدة الزمنية:</strong> تقدير الوقت اللازم
                  للوصول إلى مستوى معين باستخدام حاسبة الوقت لتعلم اللغة
                  الفرنسية.
                </li>
              </ul>
              توفر حاسبتنا للوقت اللازم لتعلم اللغة الفرنسية تقديرًا دقيقًا
              للمدة المطلوبة للوصول إلى كل مستوى، مما يساعدك على وضع خطة دراسية
              فعالة بناءً على تقييمك الحالي.
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                ما هو الفرق بين مستوى اللغة الفرنسية C2 و C1؟
              </h3>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                ما هو مستوى اللغة الفرنسية C2؟
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                مستوى اللغة الفرنسية C2، المعروف أيضًا باسم كفاءة C2، هو أعلى
                مستوى تقدمه Cambridge English Assessment. هذا المستوى يدل على
                أنك تمتلك معرفة ممتازة باللغة الفرنسية. يتطلب الوصول إلى هذا
                المستوى حوالي 1000 إلى 1200 ساعة من الدراسة.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                هل يمكنني تعلم اللغة الفرنسية في 6 أشهر؟
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                نعم، بتخصيص 4 ساعات من التعلم أسبوعيًا، يمكنك توقع الوصول من
                الصفر إلى مستوى A1 في حوالي ستة أشهر. يتطلب مستوى A1 من
                Cambridge، المعروف أيضًا بمستوى المبتدئين، حوالي 90 إلى 100 ساعة
                من الدراسة.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                كم من الوقت يستغرق الانتقال من مستوى B1 إلى B2 في اللغة
                الفرنسية؟
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                يمكنك الانتقال من مستوى B1 إلى B2 في حوالي 200 ساعة. اعتمادًا
                على مقدار الوقت الذي تخصصه أسبوعيًا، يمكنك الوصول إلى مستوى B2
                في فترة أطول أو أقصر. على سبيل المثال، مع دروس أسبوعية (6 ساعات
                في الأسبوع)، يمكنك توقع الوصول إلى هذا المستوى في فترة تتجاوز
                بقليل ثمانية أشهر.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EnglishLearningTimeCalculator;
